import { NarutoItem } from "@/interfaces/CardItem";

export function sortCards(a: NarutoItem, b: NarutoItem) {
  // Sort by chakra cost
  const aCost = a.chakra_cost ?? 0;
  const bCost = b.chakra_cost ?? 0;
  if (aCost !== bCost) {
    return aCost - bCost;
  }

  // Sort by color
  const aColor = a.color || "";
  const bColor = b.color || "";
  if (aColor !== bColor) {
    const colorOrder: string[] = [
      "Red",
      "Blue",
      "Green",
      "Yellow",
      "Purple",
      "Orange",
    ];
    const colorAIndex = colorOrder.indexOf(aColor);
    const colorBIndex = colorOrder.indexOf(bColor);
    return colorAIndex - colorBIndex;
  }

  // Sort by card type
  if (a.card_type !== b.card_type) {
    const typeOrder: string[] = ["leader", "character", "jutsu", "mission"];
    const typeAIndex = typeOrder.indexOf(a.card_type.toLowerCase());
    const typeBIndex = typeOrder.indexOf(b.card_type.toLowerCase());
    return typeAIndex - typeBIndex;
  }

  // Sort by power
  const aPow = a.pow ?? 0;
  const bPow = b.pow ?? 0;
  if (aPow !== bPow) {
    return aPow - bPow;
  }

  // Sort by damage
  const aDmg = a.dmg ?? 0;
  const bDmg = b.dmg ?? 0;
  if (aDmg !== bDmg) {
    return aDmg - bDmg;
  }

  // Finally by ID
  return a.id.localeCompare(b.id);
}
